/* eslint-disable */
import React, { useEffect, useState, useRef, useContext } from 'react';
import Card from '../../components/card.component';
import {
  Col,
  Row,
 // ProgressBar,
} from 'react-bootstrap';
import { useForm } from "react-hook-form";
import empresaFunction from './configuracion.function';
import notification from '../../components/notification.component';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { Contrasena } from '../views.general';
import { ConfigContext } from '../../context/config.context';
import ConfiguracionExtra from '../../components/configuracionextra.component';

const presetsCL = process.env.REACT_APP_PRESET_CLOUDINARY;
const cloudinaryCL = process.env.REACT_APP_CLOUDINARY_UPLOAD_URL

const Configuracion = () => {

  let initialValues = {
    formData: null,
    preview: null,
    type: null,
  };

  const { obtenerConfiguracion, config } = useContext(ConfigContext);
  const history = useHistory();
  const fileUpOne = useRef();
  const fileUpTwo = useRef();
  const { register, handleSubmit, reset, errors } = useForm();
  const [email, setEmail] = useState('');
  const [guia, setGuia] = useState('');
  const [image, setImage] = useState(initialValues);
  const [folder, setFolder] = useState('');
  const [process, setProcess] = useState(false);
  const [guiaVersion, setGuiaVersion] = useState([]);

  const clearImage = () => {
    setImage(initialValues);
  }

  const onSubmit = (data) => {
    setProcess(true);
    empresaFunction.update(data).then((response) => {
      setProcess(false);
     if (response.modifica_config) {
        setImage(initialValues);
        getEmpresa();
        obtenerConfiguracion();
        notification.success();
     } else{
        notification.warning('Ocurrio un error en la actualización');
     }
    })
  }

  useEffect(() => {
    getEmpresa();
  },[]);

  const getEmpresa = () => {
    empresaFunction.data().then((response) => {
      setEmail(response.data.banner_email);
      setGuia(response.data.logo_guia);
      setFolder(response.data.folder_assets);
      setGuiaVersion(response.data.guiaVersions);
      reset({
        ...response.data,
        guia_version_printer_id: response.data.guia_version_printer_id,
      });
    })
  }

  const openDialog = (ref) => {
    ref.current.click();
  }

  const handleImageUpload = (e, type) => {
    let w = 300;
    let h = 300;

    if (type === 'banner_email') {
      w = 620;
      h = 150;
    }

    const { files } = document.querySelector('#'+type)
    const formData = new FormData();

    if (files[0].type === 'image/png') {

    formData.append('file', files[0]);
    formData.append('upload_preset', presetsCL);
    formData.append('folder', folder);
    
    const options = {
      method: 'POST',
      body: formData,
    };

    empresaFunction.checkSizeImage(w, h, files[0]).then((response) => {
        if (response) {
          setImage({
            formData: options,
            preview: URL.createObjectURL(files[0]),
            type: type,
          });
        } else {
          notification.warning(`La imagen no cumple con la medida, debe ser de ${w}px * ${h}px`);
        }
      })
    } else {
      notification.warning(`El formato de la imagen debe ser PNG`);
   }
  }

  const uploadImagen = () => {
    setProcess(true);
    axios.post(cloudinaryCL, image.formData.body).then((res) => {
      onSubmit({ [image.type]: res.data.secure_url });
    },() => {
      notification.warning(`Ocurrio en la carga del archivo intentelo nuevamente`);
      setProcess(false);
    })
  }

return (
  <>
  <Row>
    <Col>
        <Card>
          <Row>
            <Col lg={6}>
            <div className="grupo-input">
              <button onClick={() => history.replace('/licencia')} className="btnx btnx-warn">Licencia DIBOX Platform</button>
            </div>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>

    <Row className="mt-3">
      <Col>
        <Card>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col lg={6}>    
                <div className="grupo-input">
                    <small>Empresa</small>
                    <input type="text" className={`form-control input-border`} disabled name="nombre_empresa" ref={register()} />
                </div>
                <div className="grupo-input">
                    <small>Rut</small>
                    <input type="text" className={`form-control input-border`} disabled name="rut_empresa" ref={register()} />
                </div>
                <div className="grupo-input">
                    <small>Prefijo guias</small>
                    <input type="text" className={`form-control input-border ${errors.prefijo_correlativo_guia && "is-invalid"}`} name="prefijo_correlativo_guia" ref={register({ required: true })} />
                </div>
                <div className="grupo-input">
                    <small>Dirección</small>
                    <input type="text" className={`form-control input-border ${errors.direccion_empresa && "is-invalid"}`} name="direccion_empresa" ref={register({ required: true })} />
                </div>
                <div className="grupo-input">
                    <small>Formula pies cubicos: "parametros @alto, @ancho, @largo"</small>
                    <textarea
                      className={`form-control input-border ${errors.formula_pies_cubicos && "is-invalid"}`}
                      name="formula_pies_cubicos"
                      ref={register({ required: true })} 
                    >
                    </textarea>
                </div>
            </Col>
            <Col lg={6}>
              <div className="grupo-input">
                  <small>Correo sorporte</small>
                  <input type="text" className={`form-control input-border ${errors.correo_soporte && "is-invalid"}`} name="correo_soporte" ref={register({ required: true })} />
              </div>
              <div className="grupo-input">
                  <small>Pagina web</small>
                  <input type="text" className={`form-control input-border ${errors.pagina_web && "is-invalid"}`} name="pagina_web" ref={register({ required: true })} />
              </div>
              <div className="grupo-input">
                  <small>Moneda</small>
                  <input type="text" className={`form-control input-border ${errors.currency && "is-invalid"}`} disabled  name="currency" ref={register()} />
              </div>
              <div className="grupo-input">
                  <small>Versión de guia</small>
                  <select className={`form-control input-border ${errors.guia_version_printer_id && "is-invalid"}`} name="guia_version_printer_id"  ref={register({ required: true, validate: value => value !== 'null' })}>
                    <option value="null">Seleccione..</option>
                    {guiaVersion.map((guia, i) => {
                      return <option key={i} value={guia.id} >{guia.description}</option>
                    })}
                  </select>
              </div>
              <div style={{ paddingTop: 25 }}>
                <button disabled={process} type="submit" className="btnx btnx-warn">Modificar</button>
              </div>
            </Col>
          </Row>
          </form>
        </Card>
      </Col>
    </Row>

    <Contrasena />

    <ConfiguracionExtra
      data={config}
    />

    <Row className="mt-3">
    <Col>
        <Card>
          <Row>
            <Col lg={6}>
            <div className="grupo-input">
              <small>Banner boletines ( Tamaño obligatorio 620px * 150px )</small>
              <div className="frame-image-email">
                  <img alt="Procesar imagen" src={email} className="img-fluid"/>
                  <input onChange={(e) => handleImageUpload(e, 'banner_email')} ref={fileUpOne} type="file" id="banner_email" style={{ display: 'none' }}/> 
              </div>
            </div>
            <div className="mt-3">
              <button disabled={process} type="button" onClick={() => openDialog(fileUpOne)}  className="btnx btnx-warn">Adjuntar imagen</button>
            </div>
            </Col>
            <Col lg={6}>
              { image.preview !== null && image.type === 'banner_email' ?
              <div className="grupo-input">
                <small>Previsualización</small>
                <div className="frame-image-email">
                  <img alt="Procesar imagen" src={image.preview} className="img-fluid"/>
                </div>
                <div className="mt-3">
                  <button disabled={process} type="button" onClick={uploadImagen} className="btnx btnx-warn">Guardar</button>{' '}
                  <button disabled={process} type="button" onClick={clearImage} className="btnx btnx-warn">Cancelar</button>
                </div>
              </div>
              : null }
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>

    <Row className="mt-3">
    <Col>
        <Card>
          <Row>
            <Col lg={6}>
            <div className="grupo-input">
              <small>Logo guia ( Tamaño obligatorio 300px * 300px )</small>
              <div className="frame-image-guia">
                <img alt="Procesar imagen" src={guia} className="img-fluid"/>
              </div>
            </div>
            <div className="mt-3">
            <input onChange={(e) => handleImageUpload(e, 'logo_guia')} ref={fileUpTwo} type="file" id="logo_guia" style={{ display: 'none' }}/> 
             <button disabled={process} type="button" onClick={() => openDialog(fileUpTwo)} className="btnx btnx-warn">Adjuntar imagen</button>
            </div>
            </Col>
            <Col lg={6}>
              { image.preview !== null && image.type === 'logo_guia' ?
              <div className="grupo-input">
                <small>Previsualización</small>
                <div className="frame-image-guia">
                    <img alt="Procesar imagen" src={image.preview} className="img-fluid"/>
                </div>
                <div className="mt-3">
                  <button disabled={process} type="button" onClick={uploadImagen} className="btnx btnx-warn">Guardar</button>{' '}
                  <button disabled={process} type="button" onClick={clearImage} className="btnx btnx-warn">Cancelar</button>
                </div>
              </div>
              : null }
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  </>
  )
}

export default Configuracion;